import React from 'react';
import ReactMapGL, { NavigationControl } from 'react-map-gl';

const navControlStyle = {
  left: 7,
  bottom: 35,
};

const Mapbox: React.FC<any> = React.forwardRef(({ children, mapContextProps, ...props }: any, ref: any) => {
  return (
    <ReactMapGL
      mapStyle="mapbox://styles/mapbox/streets-v9"
      doubleClickZoom={false}
      {...props}
      mapboxAccessToken={import.meta.env.VITE_MAPBOX_ACCESS_TOKEN}
      attributionControl={false}
      ref={ref}
    >
      <NavigationControl position="bottom-left" style={navControlStyle} />
      {children}
    </ReactMapGL>
  );
});

export default Mapbox;
